
import ColorPalette from '../ColorPalette/index.jsx'
import './index.less'
import { useState, useEffect } from 'react'
import React from 'react'
console.log(React)
export default function SetColor(props) {
  const [ifon, setIfon] = useState({
    isPone: false,
    color: props.color || '#ffffff'
  })

  useEffect(() => {
    const func = () => {
      setIfon({
        ...ifon,
        isPone: false
      })
    }

    window.addEventListener('click', func)

    return () => {
      window.removeEventListener('click', func)
    }
  })

  return (<div className='setColor' onClick={(e) => {
    e.stopPropagation()
  }}>
    <div className='setColor_box' onClick={(e) => {
      e.stopPropagation()
      setIfon({
        ...ifon,
        isPone: !ifon.isPone
      })
    }}>
      <span className='box_color' style={{
        backgroundColor: ifon.color
      }}></span>
    </div>
    {ifon.isPone && <div className='setColor_set'>
      <ColorPalette color={ifon.color} setColor={(colorObj) => {
        setIfon({
          ...ifon,
          color: colorObj.hex
        })
        props.setColor && props.setColor(colorObj)
      }}></ColorPalette>
    </div>}

  </div>)
}
